<div class="rt-validation">

  @if (pending) {
    <div class="rt-validation__loader" @fadeInError @fadeOutError>
      <span class="loader__text">валідація...</span>
    </div>
  }
  @if (shouldIndicateInvalidity) {
    <div @fadeInError @fadeOutError>
      <mat-error class="rt-input-error">
        {{ validationMessage }}
      </mat-error>
    </div>
  }
</div>

